import Component from '../core/Component'
import { EMITS as AUTOCOMPLETE_EMITS } from './Autocomplete'



export default class FormSearchDealers extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            country: null,
            ...options
        })

        this.ref = {
            autocomplete: null
        }

        this.autocomplete = null
        this.action = this.element.action
    }

    prepare() {
        this.autocomplete = Component.getFromElement(this.ref.autocomplete)
        if (this.autocomplete) {
            this.autocomplete.on(AUTOCOMPLETE_EMITS.CHANGE, this.handleAutocompleteChange)
            this.autocomplete.on(AUTOCOMPLETE_EMITS.SELECT, this.handleAutocompleteSelect)
        }

        this.element.addEventListener('submit', this.handleSubmit)
    }

    handleAutocompleteChange = () => {
        this.clearError()
    }

    handleAutocompleteSelect = () => {
        this.submitForm()
    }

    handleSubmit = event => {
        event.preventDefault()
        this.submitForm()
    }

    async submitForm() {
        const value = await this.autocomplete.getValue()
        const country = value.place?.address_components?.find(addressPart => addressPart.types.includes("country"))?.short_name ?? ''
        const locality = value.place?.address_components?.find(addressPart => addressPart.types.includes("locality"))?.short_name ?? ''
        let district = value.place?.address_components?.find(addressPart => addressPart.types.includes("administrative_area_level_2"))?.short_name ?? ''

        /* natvrdo prirazeni okresu  */
        if (locality === 'Bratislava' && !district) {
            district = 'bratislava-i'
        }
        if (locality === 'Košice' && !district) {
            district = 'kosice-i'
        }

        /* sk okresy maj v nazvu "Okres XXXX", tak u nich to vymlatit  */
        district = district.replace('Okres ','')

        if (!value || !value.lat || !value.lng || (this.options.country && country.toLowerCase() !== this.options.country)) {
            this.autocomplete.hide()
            this.showError('Polohu pro dané místo nebo PSČ se nepodařilo najít. Zkuste prosím jednodušší řetězec.')
            return
        }
        const url = `${this.action}`.replace('__QUERY__', encodeURIComponent(value.title)).replace('__LAT__', value.lat).replace('__LNG__', value.lng).replace('__DISTRICT__', encodeURIComponent(district))
        const link = document.createElement('a')
        link.href = url
        link.click()
    }

    showError(msg) {
        if (this.errorEl) {
            this.errorEl.innerHTML = msg
            return
        }
        this.errorEl = document.createElement('div')
        this.errorEl.className = 'InputError'
        this.errorEl.innerHTML = msg
        const formItem = this.ref.autocomplete.closest('.FormItem')
        formItem.classList.add('has-error')
        formItem.appendChild(this.errorEl)
    }

    clearError() {
        if (!this.errorEl) {
            return
        }
        this.errorEl.parentNode.removeChild(this.errorEl)
        const formItem = this.ref.autocomplete.closest('.FormItem')
        formItem.classList.remove('has-error')
        this.errorEl = null
    }
}